// D80 Tier 2 — File attachment block (custom TipTap Node).
// Renders a Notion-style file card (icon + name + size + download).
// If the file is a PDF, an inline <iframe> preview is shown below the
// card so the user can read without leaving the note.
import { Node, mergeAttributes } from '@tiptap/core';

export const FileAttachment = Node.create({
  name: 'fileAttachment',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,
  addAttributes() {
    return {
      src: { default: null },
      name: { default: 'file' },
      mime_type: { default: 'application/octet-stream' },
      size: { default: 0 },
    };
  },
  parseHTML() {
    return [{ tag: 'div[data-type="file-attachment"]' }];
  },
  renderHTML({ node, HTMLAttributes }) {
    const { src, name, mime_type, size } = node.attrs;
    const isPdf = (mime_type || '').toLowerCase() === 'application/pdf';
    const sizeStr = (() => {
      if (!size) return '';
      const u = ['B', 'KB', 'MB', 'GB']; let i = 0; let n = size;
      while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
      return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${u[i]}`;
    })();
    const attrs = mergeAttributes(HTMLAttributes, {
      'data-type': 'file-attachment', class: 'stellar-file-card',
      'data-name': name || '', 'data-mime': mime_type || '',
    });
    const card = [
      'div', { class: 'stellar-file-card-row' },
      ['div', { class: 'stellar-file-icon', 'aria-hidden': 'true' },
        isPdf ? 'PDF' : (mime_type || '').split('/')[1]?.toUpperCase()?.slice(0, 4) || 'FILE'],
      ['div', { class: 'stellar-file-meta' },
        ['div', { class: 'stellar-file-name' }, name || 'Untitled'],
        ['div', { class: 'stellar-file-sub' },
          sizeStr ? `${sizeStr} · ${mime_type || ''}` : (mime_type || ''),
        ],
      ],
      ['a', {
        href: src || '#', download: name || 'file',
        target: '_blank', rel: 'noopener noreferrer',
        class: 'stellar-media-download', 'data-testid': 'file-download',
      }, 'Download'],
    ];
    const children = [card];
    if (isPdf && src) {
      children.push([
        'iframe', {
          src, class: 'stellar-pdf-preview',
          title: name || 'PDF preview', loading: 'lazy',
          style: 'width:100%;height:520px;border:0;border-radius:8px;margin-top:8px;background:#fff;',
        },
      ]);
    }
    return ['div', attrs, ...children];
  },
  addCommands() {
    return {
      insertFile: (attrs) => ({ commands }) =>
        commands.insertContent({ type: this.name, attrs }),
    };
  },
});
